import { useEffect } from 'react'
import { AppLoader } from '../common/Helpers/AppLoader'

export const ExternalRedirect = ({ to }: { to: string }) => {
  useEffect(() => {
    window.location.replace(to)
  }, [to])

  return <AppLoader showOnPage source="external-redirect" />
}
